<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="plan-pago" titulo="Plan Pago / Servicios financieros" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">

  <div class="column is-2 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- inicio formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
          </div>
        </section>
        <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
          <br>
          <span class="tag is-primary is-large ">
            <span class="icon">
              <i class="icon-worldwide fa-spin"></i>
            </span> &nbsp;
            <span>Cargando...</span>
          </span>
        </div>

        <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">
          <a id="catalogos" (click)="ctrl.cargarCatalogo('carreras', 'carrera', 'pintar_tabla'); ctrl.cargarCatalogo('articulos', 'servicio'); "></a>
          <a id="pintar_tabla" (click)="!tieneid ? pintar_tabla(ctrl.carreras, ctrl.dato.controls.planes_pagos_detalles, true) : ''; "></a>

          <div class="field is-grouped">
            <label class="label">Nombre:</label>
            <p class="control has-icons-left has-icons-right">
              <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }"
                placeholder="Nombre" formControlName="nombre">
              <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                <i class="fa fa-warning"></i>
              </span>
              <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es
                requerido.</span>
            </p>

            <div class="control has-icons-left has-icons-right">

              <div class="b-checkbox is-info" style="margin-left:5px">
                <input id="estatus" class="styled" type="checkbox" formControlName="estatus" [checked]="ctrl.dato.get('estatus').value == 1 ? true : false">
                <label for="estatus">
                  ¿Esta activo?
                </label>
              </div>
            </div>

          </div>

          <div class="tabs is-boxed">
            <ul>
              <li [ngClass]="{ 'is-active' : tab == 1}">
                <a (click)="tab=1">
                  <span class="icon ">
                    <i class="fa fa-money"></i>
                  </span>
                  <span>Pagos</span>
                </a>
              </li>

              <li [ngClass]="{ 'is-active' : tab == 2}">
                <a (click)="tab=2">
                  <span class="icon ">
                    <i class="fa fa-percent"></i>
                  </span>
                  <span>Recargos</span>
                </a>
              </li>
            </ul>
          </div>

          <!-- pago -->
          <div [ngClass]="{ 'is-hidden': tab != 1}">
            <div class="control has-icons-left has-icons-right">
              <div class="b-checkbox is-info" style="margin-left:5px">
                <input id="colegiatura_homogenea" class="styled" type="checkbox" formControlName="colegiatura_homogenea"
                  [checked]="ctrl.dato.get('colegiatura_homogenea').value == 1 ? true : false" (click)="quitarAllMetodo(); pintar_tabla(ctrl.carreras, ctrl.dato.controls.planes_pagos_detalles); ">
                <label for="colegiatura_homogenea">
                  ¿El pago es el mismo para todos los niveles?
                </label>
              </div>
            </div>
            <table class="table is-striped is-fullwidth" formArrayName="planes_pagos_detalles">
              <thead>
                <tr>
                  <th>
                    <abbr>Carrera</abbr>
                  </th>
                  <th *ngFor="let c of tipos" style="width: 15%;">{{c.nombre}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of ctrl.dato.controls.planes_pagos_detalles.controls; let i=index" [formGroupName]="i">
                  <td>
                    <abbr>{{item.value.carreras_nombre}}</abbr>
                  </td>
                  <td colspan="5" style="width:75%">
                    <table class="table is-fullwidth" style="margin:0px; background: transparent;">
                      <tr formArrayName="articulos">
                        <td *ngFor="let c of item.controls.articulos.controls; let x = index" style="padding: 0px 10px 0px 10px;"
                          [formGroupName]="x">
                          <div formArrayName="niveles">
                            <div *ngFor="let n of c.controls.niveles.controls; let y = index" [formGroupName]="y">
                              <div class="field has-addons">
                                <p class="control">
                                  <strong class="button">{{n.value.nivel}}</strong>
                                </p>
                                <input style="width:88%" [ngClass]="{'is-danger': n.value.importe == '' }" id="importe{{i}}{{x}}{{y}}"
                                  name="importe{{i}}{{x}}{{y}}" class="input" type="number" placeholder="importe"
                                  formControlName="importe">
                                </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- recargo -->
          <div [ngClass]="{ 'is-hidden': tab != 2}">
            <div class="field is-grouped">
              <div class="control has-icons-left has-icons-right">
                <div class="b-checkbox is-info" style="margin-left:5px">
                  <input id="recargo_homogenea" class="styled" type="checkbox" formControlName="recargo_homogenea"
                    [checked]="ctrl.dato.get('recargo_homogenea').value == 1 ? true : false" (click)="quitarAllMetodoRecargo(); pintar_tabla_recargo(ctrl.carreras, ctrl.dato.controls.planes_recargos); ">
                  <label for="recargo_homogenea">
                    ¿El recargo es el mismo para todos los niveles?
                  </label>
                </div>
              </div>
              <!--
              <div class="control has-icons-left has-icons-right">
                <div class="b-checkbox is-info" style="margin-left:5px">
                  <input id="recargo_es_porcentaje" class="styled" type="checkbox" formControlName="recargo_es_porcentaje"
                    [checked]="ctrl.dato.get('recargo_es_porcentaje').value == 1 ? true : false">
                  <label for="recargo_es_porcentaje">
                    ¿El recargo es porcentaje?
                  </label>
                </div>
              </div>
              -->

              <div class="control has-icons-left has-icons-right">
                <div class="b-checkbox is-info" style="margin-left:5px">
                  <input id="recargo_es_fecha" class="styled" type="checkbox" formControlName="recargo_es_fecha"
                    [checked]="ctrl.dato.get('recargo_es_fecha').value == 1 ? true : false">
                  <label for="recargo_es_fecha">
                    ¿El recargo es un día en el mes?
                  </label>
                </div>
              </div>
            </div>
            <table class="table is-striped is-fullwidth" formArrayName="planes_recargos">
              <thead>
                <tr>
                  <th>
                    <abbr>Carrera</abbr>
                  </th>
                  <th *ngFor="let c of tipos" style="width: 18%;">{{c.nombre}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of ctrl.dato.controls.planes_recargos.controls; let i=index"
                  [formGroupName]="i">
                  <td>
                    <abbr>{{item.value.carreras_nombre}}</abbr>
                  </td>
                  <td colspan="5">
                    <table class="table is-fullwidth" style="margin:0px; background: transparent;">
                      <tr formArrayName="articulos">
                        <td *ngFor="let c of item.controls.articulos.controls; let x = index" style="padding: 0px 10px 0px 10px; width: 18%;"
                          [formGroupName]="x">
                          <div formArrayName="niveles">
                            <div *ngFor="let n of c.controls.niveles.controls; let y = index" [formGroupName]="y">

                              <div class="field has-addons">
                                <p class="control">
                                  <strong class="button">{{n.value.nivel}}</strong>
                                </p>
                                <div class="input">
                                  <div class="b-checkbox is-info" style="margin-left:5px">
                                    <input id="es_acumulado{{i}}{{x}}{{y}}" class="styled" type="checkbox" formControlName="es_acumulado" [checked]="n.get('es_acumulado').value == 1 ? true : false">
                                    <label for="es_acumulado{{i}}{{x}}{{y}}">
                                      ¿Acumular ultimo recargo?
                                    </label>
                                  </div>
                                </div>
                                <div class="control">
                                  <button class="button" [ngClass]="!n.controls.planes_recargos_detalles.invalid && n.get('planes_recargos_detalles').value.length > 0? 'is-success' : 'is-danger'" type="button" (click)="ctrl.abrirModal('dias_detalle' + '' + i + '' + x + '' + y)">
                                    <span class="icon is-small is-right">
                                      <i class="fa fa-calendar"></i>
                                    </span>
                                    <span>Días</span>
                                  </button>
                                </div>
                              </div>

                              <!-- Modal para los dias-->
                              <div class="modal" id="dias_detalle{{i}}{{x}}{{y}}" formArrayName="planes_recargos_detalles">
                                <div class="modal-background"></div>
                                <div class="modal-card" style="width: 60%">
                                  <header class="modal-card-head">
                                    <p class="modal-card-title">
                                      <i class="fa fa-success"></i> Programación días para recargo</p>
                                    <button class="delete" type="button" (click)="ctrl.cancelarModal('dias_detalle' + '' + i + '' + x + '' + y)"></button>
                                  </header>
                                  <section class="modal-card-body">
                                    <nav class="panel" *ngFor="let dia of n.controls.planes_recargos_detalles.controls; let pep = index;" [formGroupName]="pep">
                                      <div class="panel-heading" style="background: gainsboro">
                                        <strong>
                                          Recargo #{{pep + 1}}
                                        </strong>
                                        <a style="float:right; margin-top: -6px;" class="button is-danger" (click)="ctrl.quitar_form_array(n.controls.planes_recargos_detalles, pep)">
                                          <span class="icon ">
                                            <i class="icon-trash"></i>
                                          </span>
                                        </a>
                                      </div>
                                      <div class="panel-block">
                                        <div class="columns" style="width: 100%">
                                          <div class="column is-4">
                                            <div class="field">
                                              <label class="label">Si tiene BECA:</label>
                                              <div class="control is-expanded  has-icon has-icon-left">
                                                <div class="b-checkbox is-info">
                                                  <input id="quitar_beca{{i}}{{x}}{{y}}{{pep}}" class="styled" type="checkbox" formControlName="quitar_beca">
                                                  <label for="quitar_beca{{i}}{{x}}{{y}}{{pep}}">
                                                    Pierde la beca
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="column is-4">
                                            <div class="field">
                                              <label class="label">Pierde la beca:</label>
                                              <div class="control is-expanded  has-icon has-icon-left">
                                                <div class="b-checkbox is-info">
                                                  <input id="importe_mas_beca{{i}}{{x}}{{y}}{{pep}}" class="styled" type="checkbox" formControlName="importe_mas_beca">
                                                  <label for="importe_mas_beca{{i}}{{x}}{{y}}{{pep}}">
                                                    y se suma el importe
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="column is-4">
                                            <div class="field">
                                              <label class="label">El importe:</label>
                                              <div class="control is-expanded  has-icon has-icon-left">

                                                <div class="b-checkbox is-info">
                                                  <input id="es_porcentaje{{i}}{{x}}{{y}}{{pep}}" class="styled" type="checkbox" formControlName="es_porcentaje">
                                                  <label for="es_porcentaje{{i}}{{x}}{{y}}{{pep}}">
                                                    Es porcentaje
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                      <div class="panel-block">
                                        <div class="columns" style="width: 100%">

                                          <div class="column is-3">
                                            <div class="field">
                                              <label class="label">Días de inicio:</label>
                                              <div class="control is-expanded  has-icon has-icon-left">
                                                <input class="input" type="number" formControlName="dia_inicio"
                                                [min]="pep > 0 ? (n.controls.planes_recargos_detalles.controls[pep - 1].value.dia_termino + 1) : 0"
                                                (keyup)="validar_min($event, dia.controls.dia_inicio.value, pep > 0 ? (n.controls.planes_recargos_detalles.controls[pep - 1].value.dia_termino + 1) : 0)"
                                                [ngClass]="{'is-danger': dia.controls.dia_inicio.hasError('required')}">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="column is-3">
                                            <div class="field">
                                              <label class="label">Días de termino:</label>
                                              <div class="control is-expanded  has-icon has-icon-left">
                                                <input class="input" type="number" formControlName="dia_termino"
                                                [min]="dia.controls.dia_inicio.value + 1"
                                                (keyup)="validar_min($event, dia.controls.dia_termino.value, dia.controls.dia_inicio.value + 1)"
                                                [ngClass]="{'is-danger': dia.controls.dia_termino.hasError('required')}">
                                              </div>
                                            </div>
                                          </div>

                                          <div class="column is-3">
                                            <div class="field">
                                              <label class="label">Importe:</label>
                                              <div class="control is-expanded  has-icon has-icon-left">
                                                <input class="input" type="number" [max]="dia.get('es_porcentaje').value == 1 ? 100 : 9999" min="0"
                                                  placeholder="Importe de recargo" formControlName="importe" [ngClass]="{'is-danger': dia.controls.importe.hasError('required')}">
                                              </div>
                                            </div>
                                          </div>
                                          <div class="column is-3">
                                            <div class="field">
                                              <label class="label">Color:</label>
                                              <div class="control is-expanded  has-icon has-icon-left">
                                                <input class="input" type="color" placeholder="Color para el semaforo" formControlName="color" [ngClass]="{'is-danger': dia.controls.color.hasError('required')}">
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </nav>

                                  </section>
                                  <footer class="modal-card-foot">
                                    <a class="button" (click)="ctrl.cancelarModal('dias_detalle' + '' + i + '' + x + '' + y)">Continuar</a>
                                    <a class="button is-success" (click)="ctrl.agregar_form_array(n.controls.planes_recargos_detalles, form_dias)">Agregar otro</a>
                                  </footer>
                                </div>
                              </div>
                              <!-- fin modal dias-->
                            </div>
                          </div>

                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </section>
      </form>
    </div>
  </div>
</div>
